import io from "socket.io-client";
import config from '../../config/endpoints.js'
import uniqid from "uniqid";
const SOCKETHUB_ENDPOINT = config.socketHub
import _ from "lodash";
export default {
    name: 'SocketProvider',
    data: () => ({
        socket: null,
        socketId: null,
        userData: null
    }),
    computed: {
        getToken() {
            return this.$store.getters["auth/getToken"];
        }
    },
    watch: {
        getToken: {
            immediate: true,
            handler (userData, oldData) {
                console.log('OLD DATA', oldData, userData);
                if (_.isEqual(userData, oldData)) return
                let isLoggedIn = this.$store.getters["auth/getLoginStatus"];
                if (isLoggedIn && userData) {
                    this.socketInit();
                }
            }
        },
    },
    methods: {
        socketInit() {
            console.log('SOCKET INIT');
            const userData = JSON.parse(localStorage.getItem('userData'))
            const userId = userData.USER_ID
            let did = uniqid();
            this.socket = io(SOCKETHUB_ENDPOINT, {
                query: `uid=${userId}&did=${did}`,
                transports: ['websocket']
            });
            if(this.socket) {
                this.socket.on("connect", this.socketConnect);
                this.socket.on("disconnect", this.socketDisconnected);
            }
        },
        socketConnect() {
            console.log('socket connected..');
            if(this.socket&&this.socket.id) {
                setTimeout(() => {
                    // this.socket.on("ADMIN_NOTIFICATION", this. inAppNotification)
                    // this.socket.on("EMP_STATUS_NOTIFICATION", this.empStatusNotification)
                }, 5000)
            }
        },
        socketDisconnected() {
            console.log('socket disconnected..');
        },
        // inAppNotification(e) {
        //     console.log('COMMON', e)
        //         this.$store.dispatch("common/INAPP_NOTIFICATION", e)
        // },
        // empStatusNotification(e) {
        //     this.$store.dispatch("common/EMP_NOTIFICATION", e)
        // },
    },
    render() {
        if (this.$scopedSlots.default !== undefined) {
            return this.$scopedSlots.default({
                socket: this.socket,
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/api/SocketProvider.js